import { useState, useEffect, Fragment } from 'react';
import _isEmpty from 'lodash/isEmpty';
import { withFormik } from 'formik';
import { Button, Row, Col, Image } from 'react-bootstrap';
import { useStore } from 'store';
import { fetchEventTypes } from 'store/actions/catalogs';
import { carouselConfig } from 'pages/Home/HomeGifts/config';
import { Input, Select, Slider } from 'components';
import { EVENT_TYPES } from 'constants/eventTypes';
import { useWindowSize } from 'hooks';
import { transformForSelect } from 'util/transformHelpers';
import { getNestedArray } from 'util/arrays';
import { mapPropsToValues, schema, initialValues } from './config';
import './index.scss';

const EventType = ({
  giftTableFlowValues: values = {},
  onSaveData,
  setFieldValue,
  errors,
  handleNext
}) => {
  const [selectedEvent, setSelectedEvent] = useState({});
  const [selectedCategory, setSelectedCategory] = useState(
    values && values.category ? values.category : {}
  );
  const [formattedEventTypes, setFormattedEventTypes] = useState([[]]);
  const [catalogs, dispatch] = useStore((state) => state.catalogs);
  const { fullEventTypes: eventTypes = [] } = catalogs;

  const [, { isMobile }] = useWindowSize();

  const saveOption = (celebration, category) => {
    if (celebration && category) {
      onSaveData({
        celebration,
        category,
        valid: true
      });
      setSelectedCategory(category);
    }
  };

  const handleChange = (evt) => {
    const event = eventTypes.find(({ name }) => name === evt.target.value);
    setSelectedEvent((currentEvent) => event || currentEvent);
  };

  useEffect(() => {
    if (eventTypes.length > 0 && !selectedEvent.name) {
      const eventType = values.celebration
        ? eventTypes.find(({ name }) => name === values.celebration)
        : eventTypes[0];
      const initialEventType = eventType || eventTypes[0];

      if (initialEventType) {
        setSelectedEvent(initialEventType);
        setFieldValue('selectedEventType', initialEventType.name);
      }
    }
  }, [eventTypes, selectedEvent, values, setFieldValue]);

  useEffect(() => {
    const hasNotErrors = Object.values(errors).length === 0;

    if (_isEmpty(selectedCategory)) return;

    const { label, id } = selectedCategory;

    const validEvent =
      id > 18 ? label?.length > 4 && id === 21 : !_isEmpty(selectedCategory);

    onSaveData({
      celebration: selectedEvent.name,
      category: selectedCategory,
      valid: hasNotErrors && !_isEmpty(selectedEvent) && validEvent
    });
  }, [errors, selectedEvent, selectedCategory]);

  useEffect(() => {
    dispatch(fetchEventTypes(true, true));
  }, []);

  useEffect(() => {
    if (isMobile && selectedEvent.events) {
      setFormattedEventTypes(
        selectedEvent.events.length > 12
          ? getNestedArray(selectedEvent.events, 12)
          : [selectedEvent.events]
      );
    }
  }, [selectedEvent, isMobile]);

  const mapListOfEventsToRenderGiftItem = (eventCategory) => {
    const onClickHandler = () => {
      saveOption(selectedEvent.name, eventCategory);
      handleNext();
    };

    const handleBlur = (e) => {
      saveOption(eventCategory.name, {
        ...eventCategory,
        label: e.target.value
      });
    };

    return (
      <Fragment key={eventCategory.id}>
        {selectedEvent.name === EVENT_TYPES.OTHERS ? (
          <div className="SelectEventType__Other">
            <Input
              inputMode="name"
              label="Tipo de evento"
              labelClassName="text-center"
              name="otherEventType"
              onBlur={handleBlur}
            />
          </div>
        ) : (
          <div
            onKeyDown={onClickHandler}
            onKeyPress={onClickHandler}
            onClick={onClickHandler}
            role="button"
            tabIndex={0}
            className={`HomeGiftsItem ${selectedCategory.name === eventCategory.name ? 'active' : ''
              }`}
          >
            <div className="HomeGiftsItem__imgcontainer HomeGiftsItem__imgcontainer--flat d-flex justify-content-center align-content-center item-container" data-active={selectedCategory.name === eventCategory.name}>
              <Image src={eventCategory.image} alt={eventCategory.name} />
            </div>
            <p>{eventCategory.name}</p>
          </div>
        )}
      </Fragment>
    );
  };

  return (
    <div className="EvenType">
      <Row>
        <div className="buttons-container-event">
          {
            (
              eventTypes.map((event) => {
                const sameEvent = selectedEvent.name === event.name;

                const handleClick = () => {
                  setSelectedEvent(event);
                  setFieldValue('selectedEventType', event.name);
                };

                return (
                  <Button
                    key={event.name}
                    variant={sameEvent ? 'primary' : 'secondary'}
                    className="SelectEventType__Button btn-flat"
                    onClick={handleClick}
                  >
                    {event.name}
                  </Button>
                );
              })
            )
          }
        </div>
        {selectedEvent.events && (
          <>
            {isMobile ? (
              <Col xs={12} className="py-4">
                <Slider {...carouselConfig}>
                  {formattedEventTypes.map((blockOfEvents) => (
                    <div
                      key={blockOfEvents}
                      className={
                        selectedEvent.name !== EVENT_TYPES.OTHERS
                          ? 'HomeGifts__container--mobile'
                          : 'HomeGifts__container'
                      }
                    >
                      {blockOfEvents.map(mapListOfEventsToRenderGiftItem)}
                    </div>
                  ))}
                </Slider>
              </Col>
            ) : (
              <Col xs={12} className="mt-5 HomeGifts__container">
                {selectedEvent.events.map(mapListOfEventsToRenderGiftItem)}
              </Col>
            )}
          </>
        )}
      </Row>
    </div>
  );
};

export default withFormik({
  mapPropsToValues,
  initialValues,
  validationSchema: () => schema,
  validateOnBlur: true,
  validateOnChange: true
})(EventType);
